// src/js/core/wordManager.js

// Constants
const STORAGE_KEY = "unknownWordsByLanguage";
const MAX_WORDS_PER_LANGUAGE = 100;

// Initialize words from localStorage with language separation
let unknownWordsByLanguage = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");

// Function to save words to localStorage
export function saveUnknownWords() {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(unknownWordsByLanguage));
}

// Function to get current language
export function getCurrentLanguage() {
  return document.getElementById("language-select").value;
}

// Function to get unknown words for current language
export function getCurrentLanguageWords() {
  const currentLang = getCurrentLanguage();
  unknownWordsByLanguage[currentLang] = unknownWordsByLanguage[currentLang] || [];
  const words = new Set(unknownWordsByLanguage[currentLang]);

  return words;
}

// Function to update unknown words for current language
export function updateCurrentLanguageWords(wordSet) {
  const currentLang = getCurrentLanguage();
  unknownWordsByLanguage[currentLang] = [...wordSet];
  saveUnknownWords();
}

// Function to check if we can add more words
export function canAddMoreWords() {
  return getCurrentLanguageWords().size < MAX_WORDS_PER_LANGUAGE;
}

// Function to clear words for current language
export function clearCurrentLanguageWords() {
  const currentLang = getCurrentLanguage();
  unknownWordsByLanguage[currentLang] = [];
  saveUnknownWords();
}

// Function to get random subset of words for prompt using Fisher-Yates shuffle
export function getWordsForPrompt(maxWords) {
  const currentWords = Array.from(getCurrentLanguageWords());

  // If we have fewer words than requested, return all of them
  if (currentWords.length <= maxWords) {
    return currentWords;
  }

  // Create a copy of the array to shuffle
  const shuffled = [...currentWords];

  // Perform Fisher-Yates shuffle
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  // Return the first maxWords elements
  return shuffled.slice(0, maxWords);
}
